import React from 'react';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import AdditionalDetails from './AdditionalDetails/AdditionalDetails';
import CastingContactInformation from './CastingContactInformation/CastingContactInformation';
import ConflictsAndUsage from './ConflictsAndUsage/ConflictsAndUsage';
import Head from './Head/Head';
import { useStyles } from './Project.styles';

type Props = {
  data: ICastingRoleAttributes | undefined;
};

const Project: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.flexColumnContainer}>
      <Head data={data || undefined} />
      <ConflictsAndUsage data={data?.project} />
      <CastingContactInformation data={data?.project} />
      <AdditionalDetails data={data?.project} />
    </div>
  );
};

export default Project;
